function unpack(x) {
  if (typeof x == 'string') {
    const [ key, ext ] = x.split('#', 2);
    return { key, type: (ext == 'mp4') ? 'video/mp4' : 'image/jpeg' };
  }
  return x;
}

export { unpack };
